import React from 'react';
import styled from 'styled-components';
import { withRouter, Link } from 'react-router-dom';
import {
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  DropdownToggle,
  UncontrolledCollapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import heroLogo from '../../images/parameta.svg';
import messages from './headerMessages';
import { withAuthentication } from '../../common/authentication';
import { availableAssetClasses } from '../../common/domain/AssetClass';
import config from '../../config';

const Logo = styled.img`
  height: 42px;
  margin: 16px;
  position: relative;
`;

const ShortNavLink = styled(NavLink)``;

const LongNavLink = styled(NavLink)``;

// TODO(charlie): Fill in proper URLs
class PageHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { bodyClick: false };
  }

  render() {
    const { intl, location } = this.props;
    const { bodyClick } = this.state;

    return (
      <div>
        {bodyClick ? (
          <div
            id="bodyClick"
            onClick={() => {
              document.documentElement.classList.toggle('nav-open');
              this.setState({ bodyClick: true });
            }}
          />
        ) : null}
        <Navbar className="tpicap-navbar" expand="lg">
          <NavbarBrand tag={Link} to="/">
            <Logo src={heroLogo} alt="Parameta Solutions" />
          </NavbarBrand>
          <button
            className="navbar-toggler mr-3"
            id="navbarNav"
            type="button"
            onClick={() => {
              document.documentElement.classList.toggle('nav-open');
              this.setState({ bodyClick: true });
            }}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
          {this.props.authState && this.props.authState.isAuthenticated && (
            <UncontrolledCollapse navbar toggler="#navbarNav">
              <Nav navbar className="ml-5 mr-5 ml-auto">
                <UncontrolledDropdown
                  nav
                  className={
                    location.pathname.indexOf('dashboard') > -1 ? 'active' : ''
                  }
                >
                  <DropdownToggle
                    aria-haspopup
                    caret
                    color="default"
                    data-="dropdown"
                    href="#pablo"
                    id="navbarDropdownMenuLink"
                    nav
                    onClick={(e) => e.preventDefault()}
                  >
                    <FormattedMessage {...messages.dashboardsLink} />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
                    {availableAssetClasses(config.dashboards).map((assetClass) => (
                      <DropdownItem
                        key={assetClass.id}
                        tag={Link}
                        to={`/dashboards/${assetClass.id}`}
                      >
                        {`${assetClass.name} Dashboards`}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>

                <NavItem
                  className={location.pathname === '/about' ? 'active' : ''}
                >
                  <ShortNavLink tag={Link} to="/about">
                    <FormattedMessage {...messages.aboutLink} />
                  </ShortNavLink>
                </NavItem>
                <NavItem>
                  <ShortNavLink
                    href={`mailto:${intl.formatMessage(messages.contactEmail)}`}
                  >
                    <FormattedMessage {...messages.helpLink} />
                  </ShortNavLink>
                </NavItem>
                {this.props.authState && this.props.authState.isMappingAdmin && (
                  <>
                    <UncontrolledDropdown
                      nav
                      className={
                        location.pathname.indexOf('data-mapping-admin') > -1
                          ? 'active'
                          : ''
                      }
                    >
                      <DropdownToggle
                        aria-haspopup
                        caret
                        color="default"
                        data-toggle="dropdown"
                        href="#pablo"
                        id="navbarDropdownAdminLink"
                        nav
                        onClick={(e) => e.preventDefault()}
                      >
                        <FormattedMessage {...messages.dataMappingAdminLink} />
                      </DropdownToggle>
                      <DropdownMenu aria-labelledby="navbarDropdownAdminLink">
                        <DropdownItem
                          tag={Link}
                          to="/data-mapping-admin/rates-field"
                        >
                          <FormattedMessage
                            {...messages.ratesFieldMappingLink}
                          />
                        </DropdownItem>
                        <DropdownItem
                          tag={Link}
                          to="/data-mapping-admin/rates-fixing"
                        >
                          <FormattedMessage
                            {...messages.ratesFixingProxyMappingLink}
                          />
                        </DropdownItem>
                        <DropdownItem
                          tag={Link}
                          to="/data-mapping-admin/legal-entity"
                        >
                          <FormattedMessage
                            {...messages.LegalEntityMappingLink}
                          />
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                    <UncontrolledDropdown
                      nav
                      className={
                        location.pathname.indexOf('data-mapping-audit') > -1
                          ? 'active'
                          : ''
                      }
                    >
                      <DropdownToggle
                        aria-haspopup
                        caret
                        color="default"
                        data-toggle="dropdown"
                        href="#pablo"
                        id="navbarDropdownAuditLink"
                        nav
                        onClick={(e) => e.preventDefault()}
                      >
                        <FormattedMessage {...messages.dataMappingAuditLink} />
                      </DropdownToggle>
                      <DropdownMenu aria-labelledby="navbarDropdownAuditLink">
                        <DropdownItem
                          tag={Link}
                          to="/data-mapping-audit/rates-field"
                        >
                          <FormattedMessage {...messages.ratesFieldAuditLink} />
                        </DropdownItem>
                        <DropdownItem
                          tag={Link}
                          to="/data-mapping-audit/rates-fixing"
                        >
                          <FormattedMessage
                            {...messages.ratesFixingProxyAuditLink}
                          />
                        </DropdownItem>
                        <DropdownItem
                          tag={Link}
                          to="/data-mapping-audit/legal-entity"
                        >
                          <FormattedMessage
                            {...messages.LegalEntityAuditLink}
                          />
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </>
                )}
                <UncontrolledDropdown
                  nav
                  className={
                    location.pathname.indexOf('upload') > -1 ||
                    location.pathname.indexOf('account') > -1
                      ? 'active'
                      : ''
                  }
                >
                  <DropdownToggle
                    aria-haspopup
                    caret
                    color="default"
                    data-toggle="dropdown"
                    href="#pablo"
                    id="navbarDropdownMenuLink"
                    nav
                    onClick={(e) => e.preventDefault()}
                  >
                    <FormattedMessage {...messages.yourAccountLink} />
                  </DropdownToggle>
                  <DropdownMenu aria-labelledby="navbarDropdownMenuLink">
                    {true ? (
                      <>
                        <DropdownItem tag={Link} to="/account">
                          <FormattedMessage {...messages.settingsLink} />
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/uploads">
                          <FormattedMessage {...messages.yourUploadsLink} />
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/upload">
                          <FormattedMessage
                            {...messages.uploadTransactionFile}
                          />
                        </DropdownItem>
                        <DropdownItem
                          onClick={() => {
                            this.props.authService.logout();
                          }}
                        >
                          <FormattedMessage {...messages.logoutLink} />
                        </DropdownItem>
                      </>
                    ) : (
                      <>
                        <DropdownItem href="mailto:ParametaSupport@tpicap.com?Subject=Parameta Trading Analytics Account Request">
                          <FormattedMessage {...messages.requestAccountLink} />
                        </DropdownItem>
                      </>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </UncontrolledCollapse>
          )}
          {!this.props.authState ||
            (!this.props.authState.isAuthenticated && (
              <Nav navbar className="ml-5 mr-5 ml-auto">
                <NavItem>
                  <ShortNavLink
                    href="#"
                    onClick={() => this.props.authService.login()}
                  >
                    <FormattedMessage {...messages.loginLink} />
                  </ShortNavLink>
                </NavItem>
                <NavItem>
                  <LongNavLink href="mailto:ParametaSupport@tpicap.com?Subject=Parameta Trading Analytics Account Request">
                    <FormattedMessage {...messages.requestAccountLink} />
                  </LongNavLink>
                </NavItem>
              </Nav>
            ))}
        </Navbar>
      </div>
    );
  }
}

export const Header = withAuthentication(withRouter(injectIntl(PageHeader)));
